// @flow

export type ReceivePromotions = 'bravissimo/promotions/RECEIVE_PROMOTIONS';

export const RECEIVE_PROMOTIONS: ReceivePromotions =
  'bravissimo/promotions/RECEIVE_PROMOTIONS';
